module.exports = __webpack_public_path__ + "assets/f72a199d1c1012744829432eee16eb8e.png";